"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAnimationFunctions;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var TWEEN = _interopRequireWildcard(require("@tweenjs/tween.js"));
var _excluded = ["threeJs", "object", "position", "rotation"];
function getAnimationFunctions(_ref) {
  var THREE = _ref.THREE,
    getCameraProps = _ref.getCameraProps;
  function cameraMoveByControls(_x, _x2, _x3) {
    return _cameraMoveByControls.apply(this, arguments);
  }
  function _cameraMoveByControls() {
    _cameraMoveByControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(threeJs, control, cameraMoveTime) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return new Promise(function (resolve) {
              threeJs.cameraAnim = /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(time) {
                  var spherical, zoom, callback, offsetSpherical, cameraProps;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        spherical = {
                          theta: 0,
                          phi: 0,
                          radius: 0
                        };
                        zoom = 0;
                        callback = function callback(resolve) {
                          return setTimeout(resolve, 1000);
                        };
                        offsetSpherical = getCameraPosSpherical(threeJs);
                        if (control === "up") {
                          spherical.phi = Math.max(threeJs.controls.minPolarAngle, Math.min(threeJs.controls.maxPolarAngle, -Math.PI / 2));
                        }
                        if (control === "left") {
                          spherical.phi = Math.max(threeJs.controls.minPolarAngle, Math.min(threeJs.controls.maxPolarAngle, Math.PI / 2)) - offsetSpherical.phi;
                          spherical.theta = Math.max(threeJs.controls.minAzimuthAngle, Math.min(threeJs.controls.maxAzimuthAngle, -Math.PI / 2)) - offsetSpherical.theta;
                        }
                        if (control === "right") {
                          spherical.phi = Math.max(threeJs.controls.minPolarAngle, Math.min(threeJs.controls.maxPolarAngle, Math.PI / 2)) - offsetSpherical.phi;
                          spherical.theta = Math.max(threeJs.controls.minAzimuthAngle, Math.min(threeJs.controls.maxAzimuthAngle, Math.PI / 2)) - offsetSpherical.theta;
                        }
                        if (control === "center") {
                          cameraProps = getCameraProps(0, threeJs);
                          zoom = Math.round((cameraProps.zoom - threeJs.camera.zoom) * 100) / 100;
                          Object.entries(getAddSphericalByPosition(threeJs, cameraProps.position, cameraProps.target)).forEach(function (entry) {
                            var _entry = (0, _slicedToArray2["default"])(entry, 2),
                              key = _entry[0],
                              value = _entry[1];
                            spherical[key] = value;
                          });
                          callback = function callback(resolve) {
                            cameraProps.set();
                            setTimeout(resolve, 1000);
                          };
                        }
                        _context.next = 10;
                        return cameraAnim(threeJs, spherical, zoom, undefined, cameraMoveTime, time);
                      case 10:
                        if (!callback) {
                          _context.next = 13;
                          break;
                        }
                        _context.next = 13;
                        return new Promise(callback);
                      case 13:
                        resolve();
                      case 14:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x19) {
                  return _ref3.apply(this, arguments);
                };
              }();
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _cameraMoveByControls.apply(this, arguments);
  }
  function objectsAnim(_x4, _x5, _x6, _x7) {
    return _objectsAnim.apply(this, arguments);
  }
  function _objectsAnim() {
    _objectsAnim = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(threeJs, addPosition, addRotation, startTime) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return new Promise(function (resolve) {
              var tweenData = {
                pX: 0,
                pY: 0,
                pZ: 0,
                rX: 0,
                rY: 0,
                rZ: 0
              };
              var position = threeJs.world ? new THREE.Vector3(threeJs.world.position.x, threeJs.world.position.y, threeJs.world.position.z) : null;
              var rotation = threeJs.world ? new THREE.Vector3(threeJs.world.rotation.x, threeJs.world.rotation.y, threeJs.world.rotation.z) : null;
              function update(_ref4) {
                var _ref4$pX = _ref4.pX,
                  pX = _ref4$pX === void 0 ? 0 : _ref4$pX,
                  _ref4$pY = _ref4.pY,
                  pY = _ref4$pY === void 0 ? 0 : _ref4$pY,
                  _ref4$pZ = _ref4.pZ,
                  pZ = _ref4$pZ === void 0 ? 0 : _ref4$pZ,
                  _ref4$rX = _ref4.rX,
                  rX = _ref4$rX === void 0 ? 0 : _ref4$rX,
                  _ref4$rY = _ref4.rY,
                  rY = _ref4$rY === void 0 ? 0 : _ref4$rY,
                  _ref4$rZ = _ref4.rZ,
                  rZ = _ref4$rZ === void 0 ? 0 : _ref4$rZ;
                if (!threeJs.world) {
                  return;
                }
                if (!position) {
                  position = new THREE.Vector3(threeJs.world.position.x, threeJs.world.position.y, threeJs.world.position.z);
                }
                if (!rotation) {
                  rotation = new THREE.Vector3(threeJs.world.rotation.x, threeJs.world.rotation.y, threeJs.world.rotation.z);
                }
                threeJs.world.position.x = position.x + pX;
                threeJs.world.position.y = position.y + pY;
                threeJs.world.position.z = position.z + pZ;
                threeJs.world.rotation.x = rotation.x + rX;
                threeJs.world.rotation.y = rotation.y + rY;
                threeJs.world.rotation.z = rotation.z + rZ;
              }
              var to = {
                pX: addPosition.x,
                pY: addPosition.y,
                pZ: addPosition.z,
                rX: addRotation.x,
                rY: addRotation.y,
                rZ: addRotation.z
              };
              var cameraMoveTime = threeJs.animationProps.cameraMoveTime;
              var notEqual = Object.keys(tweenData).find(function (key) {
                return tweenData[key] !== to[key];
              });
              var tween = new TWEEN.Tween(tweenData).to(to, notEqual ? cameraMoveTime : 100).onUpdate(function () {
                update((0, _objectSpread2["default"])({}, tweenData));
              }).easing(TWEEN.Easing[threeJs.animationProps.objectsEasingFunction][threeJs.animationProps.objectsEasingType]).onComplete(function () {
                update((0, _objectSpread2["default"])({}, to));
                tween.stop();
                if (threeJs.runningTweens.indexOf(tween) > -1) {
                  threeJs.runningTweens.splice(threeJs.runningTweens.indexOf(tween), 1);
                }
                resolve();
              });
              threeJs.runningTweens.push(tween);
              tween.start(startTime);
              threeJs.objectsAnim = null;
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _objectsAnim.apply(this, arguments);
  }
  function objectsMove(_x8, _x9, _x10) {
    return _objectsMove.apply(this, arguments);
  }
  function _objectsMove() {
    _objectsMove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(threeJs, newPosition, newRotation) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return new Promise(function (resolve) {
              threeJs.objectsAnim = /*#__PURE__*/function () {
                var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(time) {
                  var addPosition, addRotation;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        addPosition = {
                          x: newPosition.x - threeJs.world.position.x,
                          y: newPosition.y - threeJs.world.position.y,
                          z: newPosition.z - threeJs.world.position.z
                        };
                        addRotation = {
                          x: newRotation.x - threeJs.world.rotation.x,
                          y: newRotation.y - threeJs.world.rotation.y,
                          z: newRotation.z - threeJs.world.rotation.z
                        };
                        _context4.next = 4;
                        return objectsAnim(threeJs, addPosition, addRotation, time);
                      case 4:
                        resolve();
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x20) {
                  return _ref5.apply(this, arguments);
                };
              }();
            });
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _objectsMove.apply(this, arguments);
  }
  function cameraMoveToPosition(_x11, _x12) {
    return _cameraMoveToPosition.apply(this, arguments);
  }
  function _cameraMoveToPosition() {
    _cameraMoveToPosition = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(threeJs, newPosition) {
      var newTarget,
        newZoom,
        _args7 = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            newTarget = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : threeJs.target;
            newZoom = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : threeJs.camera.zoom;
            _context7.next = 4;
            return new Promise(function (resolve) {
              threeJs.cameraAnim = /*#__PURE__*/function () {
                var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(time) {
                  var spherical, target, zoom;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        spherical = {
                          theta: 0,
                          phi: 0
                        };
                        target = {
                          x: newTarget.x - threeJs.target.x,
                          y: newTarget.y - threeJs.target.y,
                          z: newTarget.z - threeJs.target.z
                        };
                        zoom = Math.round((newZoom - threeJs.camera.zoom) * 100) / 100;
                        Object.entries(getAddSphericalByPosition(threeJs, newPosition, newTarget)).forEach(function (entry) {
                          var _entry2 = (0, _slicedToArray2["default"])(entry, 2),
                            key = _entry2[0],
                            value = _entry2[1];
                          spherical[key] = value;
                        });
                        _context6.next = 6;
                        return cameraAnim(threeJs, spherical, zoom, target, undefined, time);
                      case 6:
                        resolve();
                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x21) {
                  return _ref6.apply(this, arguments);
                };
              }();
            });
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _cameraMoveToPosition.apply(this, arguments);
  }
  function getNCameraPosSpherical() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p$n = p.n,
      n = _p$n === void 0 ? 0 : _p$n,
      threeJs = p.threeJs;
    var cameraProps = getCameraProps(n, threeJs);
    var target = cameraProps.target;
    var position = p.position || cameraProps.position;
    var cameraPropName = !n ? "camera" : "camera" + n;
    var quat = new THREE.Quaternion().setFromUnitVectors(threeJs[cameraPropName].up, new THREE.Vector3(0, 1, 0));
    var quatInverse = quat.clone().invert();
    var offset = new THREE.Vector3();
    var spherical = new THREE.Spherical();
    offset.copy(position).sub(target);
    offset.applyQuaternion(quat);
    spherical.setFromVector3(offset);
    return {
      spherical: spherical,
      offset: offset,
      quatInverse: quatInverse,
      target: target
    };
  }
  function getCameraPosSpherical(threeJs) {
    var quat = new THREE.Quaternion().setFromUnitVectors(threeJs.camera.up, new THREE.Vector3(0, 1, 0));
    var position = threeJs.camera.position;
    var offset = new THREE.Vector3();
    var spherical = new THREE.Spherical();
    offset.copy(position).sub(threeJs.target);
    offset.applyQuaternion(quat);
    spherical.setFromVector3(offset);
    return spherical;
  }
  function getAddSphericalByPosition(threeJs, newPosition, newTarget) {
    var spherical = {
      theta: 0,
      phi: 0,
      radius: 0
    };
    var offsetSpherical = getCameraPosSpherical(threeJs);
    if (newPosition) {
      var quat = new THREE.Quaternion().setFromUnitVectors(threeJs.camera.up, new THREE.Vector3(0, 1, 0));
      var position = new THREE.Vector3(newPosition.x, newPosition.y, newPosition.z);
      var offset = new THREE.Vector3();
      var newPositionSpherical = new THREE.Spherical();
      offset.copy(position).sub(newTarget || threeJs.target);
      offset.applyQuaternion(quat);
      newPositionSpherical.setFromVector3(offset);
      spherical.phi = newPositionSpherical.phi - offsetSpherical.phi;
      spherical.theta = newPositionSpherical.theta - offsetSpherical.theta;
      spherical.radius = newPositionSpherical.radius - offsetSpherical.radius;
    }
    return spherical;
  }
  function cameraAnim(_x13) {
    return _cameraAnim.apply(this, arguments);
  }
  function _cameraAnim() {
    _cameraAnim = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(threeJs) {
      var addSpherical,
        addZoom,
        addTarget,
        cameraMoveTime,
        startTime,
        _args8 = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            addSpherical = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {
              theta: 0,
              phi: 0,
              radius: 0
            };
            addZoom = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 0;
            addTarget = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : {
              x: 0,
              y: 0,
              z: 0
            };
            cameraMoveTime = _args8.length > 4 && _args8[4] !== undefined ? _args8[4] : threeJs.animationProps.cameraMoveTime;
            startTime = _args8.length > 5 ? _args8[5] : undefined;
            _context8.next = 7;
            return new Promise(function (resolve) {
              var tweenData = {
                theta: 0,
                phi: 0,
                radius: 0,
                zoom: 0,
                x: 0,
                y: 0,
                z: 0
              };
              var quat = new THREE.Quaternion().setFromUnitVectors(threeJs.camera.up, new THREE.Vector3(0, 1, 0));
              var quatInverse = quat.clone().invert();
              var position = threeJs.camera ? new THREE.Vector3().copy(threeJs.camera.position) : null;
              var startZoom = threeJs.camera ? threeJs.camera.zoom : null;
              var startTarget = threeJs.target ? new THREE.Vector3().copy(threeJs.target) : null;
              function update(_ref7) {
                var _ref7$theta = _ref7.theta,
                  theta = _ref7$theta === void 0 ? 0 : _ref7$theta,
                  _ref7$phi = _ref7.phi,
                  phi = _ref7$phi === void 0 ? 0 : _ref7$phi,
                  _ref7$radius = _ref7.radius,
                  radius = _ref7$radius === void 0 ? 0 : _ref7$radius,
                  _ref7$zoom = _ref7.zoom,
                  zoom = _ref7$zoom === void 0 ? 0 : _ref7$zoom,
                  _ref7$x = _ref7.x,
                  x = _ref7$x === void 0 ? 0 : _ref7$x,
                  _ref7$y = _ref7.y,
                  y = _ref7$y === void 0 ? 0 : _ref7$y,
                  _ref7$z = _ref7.z,
                  z = _ref7$z === void 0 ? 0 : _ref7$z;
                if (!threeJs.camera || !threeJs.target) {
                  return;
                }
                if (!position) {
                  position = new THREE.Vector3().copy(threeJs.camera.position);
                }
                if (!startZoom) {
                  startZoom = threeJs.camera.zoom;
                }
                if (!startTarget) {
                  startTarget = new THREE.Vector3().copy(threeJs.target);
                }
                var target = new THREE.Vector3().copy(startTarget);
                target.x += x;
                target.y += y;
                target.z += z;
                var offset = new THREE.Vector3();
                offset.copy(position).sub(startTarget);
                offset.applyQuaternion(quat);
                var spherical = new THREE.Spherical();
                spherical.setFromVector3(offset);
                spherical.theta += theta;
                spherical.phi += phi;
                spherical.radius += radius;
                spherical.makeSafe();
                offset.setFromSpherical(spherical);
                offset.applyQuaternion(quatInverse);
                threeJs.camera.position.copy(startTarget).add(offset).add(new THREE.Vector3(x, y, z));
                threeJs.camera.lookAt(target);
                threeJs.camera.zoom = startZoom + zoom;
              }
              var to = {
                theta: addSpherical.theta,
                phi: addSpherical.phi,
                radius: addSpherical.radius,
                zoom: addZoom * 1000,
                x: addTarget.x,
                y: addTarget.y,
                z: addTarget.z
              };
              var notEqual = Object.keys(tweenData).find(function (key) {
                return tweenData[key] !== to[key];
              });
              var tween = new TWEEN.Tween(tweenData).to(to, notEqual ? cameraMoveTime : 100).onUpdate(function () {
                update({
                  theta: tweenData.theta,
                  phi: tweenData.phi,
                  radius: tweenData.radius,
                  zoom: Math.round(tweenData.zoom) / 1000,
                  x: tweenData.x,
                  y: tweenData.y,
                  z: tweenData.z
                });
                if (threeJs.camera) {
                  threeJs.updateShadowMap();
                  threeJs.camera.updateProjectionMatrix();
                }
              }).easing(TWEEN.Easing[threeJs.animationProps.cameraEasingFunction][threeJs.animationProps.cameraEasingType]).onComplete(function () {
                update({
                  theta: to.theta,
                  phi: to.phi,
                  radius: to.radius,
                  zoom: Math.round(to.zoom) / 1000,
                  x: to.x,
                  y: to.y,
                  z: to.z
                });
                if (threeJs.target) {
                  var target = new THREE.Vector3().copy(startTarget);
                  target.x += addTarget.x;
                  target.y += addTarget.y;
                  target.z += addTarget.z;
                  threeJs.target.x = target.x;
                  threeJs.target.y = target.y;
                  threeJs.target.z = target.z;
                }
                if (threeJs.camera) {
                  threeJs.updateShadowMap();
                  threeJs.camera.updateProjectionMatrix();
                  threeJs.controls.update();
                }
                tween.stop();
                if (threeJs.runningTweens.indexOf(tween) > -1) {
                  threeJs.runningTweens.splice(threeJs.runningTweens.indexOf(tween), 1);
                }
                resolve();
              });
              threeJs.runningTweens.push(tween);
              tween.start(startTime);
              threeJs.cameraAnim = null;
            });
          case 7:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _cameraAnim.apply(this, arguments);
  }
  function animationMap(_x14, _x15) {
    return _animationMap.apply(this, arguments);
  }
  function _animationMap() {
    _animationMap = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11(key, _ref2) {
      var threeJs, toggleSplitScreen, nextCompositionIndex, waitTimeBetweenAnimations, sI, cI;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            threeJs = _ref2.threeJs, toggleSplitScreen = _ref2.toggleSplitScreen, nextCompositionIndex = _ref2.nextCompositionIndex;
            waitTimeBetweenAnimations = threeJs.animationProps.waitTimeBetweenAnimations;
            if (!(key === "ArrowDown")) {
              _context11.next = 7;
              break;
            }
            _context11.next = 5;
            return cameraMoveByControls(threeJs, "center");
          case 5:
            _context11.next = 7;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitTimeBetweenAnimations);
            });
          case 7:
            if (!(key === "ArrowUp")) {
              _context11.next = 12;
              break;
            }
            _context11.next = 10;
            return cameraMoveByControls(threeJs, "up");
          case 10:
            _context11.next = 12;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitTimeBetweenAnimations);
            });
          case 12:
            if (!(key === "ArrowLeft")) {
              _context11.next = 17;
              break;
            }
            _context11.next = 15;
            return cameraMoveByControls(threeJs, "left");
          case 15:
            _context11.next = 17;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitTimeBetweenAnimations);
            });
          case 17:
            if (!(key === "ArrowRight")) {
              _context11.next = 22;
              break;
            }
            _context11.next = 20;
            return cameraMoveByControls(threeJs, "right");
          case 20:
            _context11.next = 22;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitTimeBetweenAnimations);
            });
          case 22:
            if (!(key === " ")) {
              _context11.next = 28;
              break;
            }
            _context11.next = 25;
            return toggleSplitScreen();
          case 25:
            threeJs.setButtonsForControls();
            _context11.next = 28;
            return new Promise(function (resolve) {
              return setTimeout(resolve, waitTimeBetweenAnimations);
            });
          case 28:
            if (key === "enableFirstAnimation") {
              //nothing, it was happened
            }
            if (!(key === "D")) {
              _context11.next = 34;
              break;
            }
            sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
            cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
            _context11.next = 34;
            return new Promise( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10(resolve) {
                var waitForRealEnd;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      threeJs.waitBeforeStartAnimation = new Promise(function (resolve) {
                        threeJs.waitBeforeStartAnimationResolve = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9() {
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                            while (1) switch (_context9.prev = _context9.next) {
                              case 0:
                                if (!waitForRealEnd) {
                                  _context9.next = 3;
                                  break;
                                }
                                _context9.next = 3;
                                return new Promise(waitForRealEnd);
                              case 3:
                                resolve();
                                threeJs.waitBeforeStartAnimation = null;
                              case 5:
                              case "end":
                                return _context9.stop();
                            }
                          }, _callee9);
                        }));
                      });
                      nextCompositionIndex();
                      _context10.next = 4;
                      return new Promise(function (resolve) {
                        var _int = sI(function () {
                          if (threeJs.addObjectsAnimationIsRunning) {
                            cI(_int);
                            resolve();
                          }
                        }, 1);
                      });
                    case 4:
                      waitForRealEnd = function waitForRealEnd(resolve) {
                        var _int2 = sI(function () {
                          if (!threeJs.addObjectsAnimationIsRunning) {
                            cI(_int2);
                            resolve();
                          }
                        }, 1);
                      };
                      _context10.next = 7;
                      return new Promise(function (resolve) {
                        var _int3 = sI(function () {
                          if (threeJs.waitForCameraPosFromUpdateObjects) {
                            return;
                          }
                          if (threeJs.addObjectsAnimationIsFinal) {
                            if (!threeJs.addObjectsAnimationChildIsRunning || !threeJs.addObjectsAnimationIsRunning) {
                              cI(_int3);
                              resolve();
                            }
                          } else {
                            if (!threeJs.addObjectsAnimationIsRunning) {
                              cI(_int3);
                              resolve();
                            }
                          }
                        }, 1);
                      });
                    case 7:
                      resolve();
                    case 8:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return function (_x22) {
                return _ref8.apply(this, arguments);
              };
            }());
          case 34:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _animationMap.apply(this, arguments);
  }
  function startAnimation(_x16) {
    return _startAnimation.apply(this, arguments);
  }
  function _startAnimation() {
    _startAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15(props) {
      var threeJs, animation, _props$enableAnimatio, enableAnimationKeys, currentCompositionIndex, enabledKeys;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            threeJs = props.threeJs, animation = props.animation, _props$enableAnimatio = props.enableAnimationKeys, enableAnimationKeys = _props$enableAnimatio === void 0 ? [] : _props$enableAnimatio;
            if (!threeJs.runningAnimation) {
              _context15.next = 5;
              break;
            }
            if (threeJs.runningAnimationResolve) {
              threeJs.runningAnimationResolve();
            }
            _context15.next = 5;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 5:
            console.log("[APP] Start animation...");
            currentCompositionIndex = threeJs.compositionIndex;
            console.log("[APP] Animation, composition:[" + currentCompositionIndex + "]");
            enabledKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space", "D"].concat((0, _toConsumableArray2["default"])(enableAnimationKeys));
            _context15.next = 11;
            return new Promise( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14(resolve) {
                var resolvers;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      resolvers = [resolve];
                      threeJs.runningAnimationResolve = function () {
                        resolvers.forEach(function (resolve) {
                          return resolve();
                        });
                        threeJs.runningAnimation = null;
                        threeJs.runningAnimationResolve = null;
                      };
                      console.log("[APP] Animation scene");
                      if (!animation.length) {
                        _context14.next = 6;
                        break;
                      }
                      _context14.next = 6;
                      return new Promise(function (resolve) {
                        resolvers.push(resolve);
                        setTimeout(resolve, threeJs.animationProps.waitTimeBeforeAnimation);
                      });
                    case 6:
                      _context14.next = 8;
                      return new Promise( /*#__PURE__*/function () {
                        var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13(resolve) {
                          var animationIndex, next, _next;
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
                            while (1) switch (_context13.prev = _context13.next) {
                              case 0:
                                _next = function _next3() {
                                  _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12() {
                                    var key, k;
                                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
                                      while (1) switch (_context12.prev = _context12.next) {
                                        case 0:
                                          if (threeJs.runningAnimationResolve) {
                                            _context12.next = 2;
                                            break;
                                          }
                                          return _context12.abrupt("return", resolve());
                                        case 2:
                                          animationIndex = animationIndex + 1;
                                          if (!(typeof animation[animationIndex] !== "undefined")) {
                                            _context12.next = 20;
                                            break;
                                          }
                                          key = animation[animationIndex];
                                          if (!(key && enabledKeys.indexOf(key) > -1 || key && !isNaN(Number(key)))) {
                                            _context12.next = 16;
                                            break;
                                          }
                                          if (isNaN(Number(key))) {
                                            _context12.next = 12;
                                            break;
                                          }
                                          console.log("[APP] Animation wait:", Number(key));
                                          _context12.next = 10;
                                          return new Promise(function (resolve) {
                                            return setTimeout(resolve, Number(key));
                                          });
                                        case 10:
                                          _context12.next = 16;
                                          break;
                                        case 12:
                                          k = key === "Space" ? " " : key;
                                          console.log("[APP] Animation key:", key);
                                          _context12.next = 16;
                                          return animationMap(k, props);
                                        case 16:
                                          _context12.next = 18;
                                          return next();
                                        case 18:
                                          _context12.next = 21;
                                          break;
                                        case 20:
                                          resolve();
                                        case 21:
                                        case "end":
                                          return _context12.stop();
                                      }
                                    }, _callee12);
                                  }));
                                  return _next.apply(this, arguments);
                                };
                                next = function _next2() {
                                  return _next.apply(this, arguments);
                                };
                                resolvers.push(resolve);
                                animationIndex = -1;
                                _context13.next = 6;
                                return next();
                              case 6:
                                return _context13.abrupt("return", _context13.sent);
                              case 7:
                              case "end":
                                return _context13.stop();
                            }
                          }, _callee13);
                        }));
                        return function (_x24) {
                          return _ref11.apply(this, arguments);
                        };
                      }());
                    case 8:
                      if (threeJs.runningAnimationResolve) {
                        threeJs.runningAnimationResolve();
                      }
                    case 9:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              return function (_x23) {
                return _ref10.apply(this, arguments);
              };
            }());
          case 11:
            threeJs.runningAnimation = _context15.sent;
            console.log("[APP] Animation ended", currentCompositionIndex);
            if (threeJs.waitBeforeStartAnimationResolve) {
              threeJs.waitBeforeStartAnimationResolve();
            }
          case 14:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _startAnimation.apply(this, arguments);
  }
  function objectAnim(_x17) {
    return _objectAnim.apply(this, arguments);
  }
  function _objectAnim() {
    _objectAnim = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(props) {
      var threeJs, object, addPosition, addRotation, startTime, _props$time, time, _props$easingFunction, easingFunction, _props$easingType, easingType;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            threeJs = props.threeJs, object = props.object, addPosition = props.addPosition, addRotation = props.addRotation, startTime = props.startTime, _props$time = props.time, time = _props$time === void 0 ? 1 : _props$time, _props$easingFunction = props.easingFunction, easingFunction = _props$easingFunction === void 0 ? "Quadratic" : _props$easingFunction, _props$easingType = props.easingType, easingType = _props$easingType === void 0 ? "InOut" : _props$easingType;
            _context16.next = 3;
            return new Promise(function (resolve) {
              var tweenData = {
                pX: 0,
                pY: 0,
                pZ: 0,
                rX: 0,
                rY: 0,
                rZ: 0
              };
              var position = object ? new THREE.Vector3(object.position.x, object.position.y, object.position.z) : null;
              var rotation = object ? new THREE.Vector3(object.rotation.x, object.rotation.y, object.rotation.z) : null;
              function update(_ref12) {
                var _ref12$pX = _ref12.pX,
                  pX = _ref12$pX === void 0 ? 0 : _ref12$pX,
                  _ref12$pY = _ref12.pY,
                  pY = _ref12$pY === void 0 ? 0 : _ref12$pY,
                  _ref12$pZ = _ref12.pZ,
                  pZ = _ref12$pZ === void 0 ? 0 : _ref12$pZ,
                  _ref12$rX = _ref12.rX,
                  rX = _ref12$rX === void 0 ? 0 : _ref12$rX,
                  _ref12$rY = _ref12.rY,
                  rY = _ref12$rY === void 0 ? 0 : _ref12$rY,
                  _ref12$rZ = _ref12.rZ,
                  rZ = _ref12$rZ === void 0 ? 0 : _ref12$rZ;
                if (!object) {
                  return;
                }
                if (!position) {
                  position = new THREE.Vector3(object.position.x, object.position.y, object.position.z);
                }
                if (!rotation) {
                  rotation = new THREE.Vector3(object.rotation.x, object.rotation.y, object.rotation.z);
                }
                object.position.x = position.x + pX;
                object.position.y = position.y + pY;
                object.position.z = position.z + pZ;
                object.rotation.x = rotation.x + rX;
                object.rotation.y = rotation.y + rY;
                object.rotation.z = rotation.z + rZ;
              }
              var to = {
                pX: addPosition.x,
                pY: addPosition.y,
                pZ: addPosition.z,
                rX: addRotation.x,
                rY: addRotation.y,
                rZ: addRotation.z
              };
              var notEqual = Object.keys(tweenData).find(function (key) {
                return tweenData[key] !== to[key];
              });
              var tween = new TWEEN.Tween(tweenData).to(to, notEqual ? time : 1).onUpdate(function () {
                update((0, _objectSpread2["default"])({}, tweenData));
              }).easing(TWEEN.Easing[easingFunction][easingType]).onComplete(function () {
                update((0, _objectSpread2["default"])({}, to));
                tween.stop();
                if (threeJs.runningTweens.indexOf(tween) > -1) {
                  threeJs.runningTweens.splice(threeJs.runningTweens.indexOf(tween), 1);
                }
                resolve();
              });
              threeJs.runningTweens.push(tween);
              tween.start(startTime);
            });
          case 3:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    return _objectAnim.apply(this, arguments);
  }
  function objectMove(_x18) {
    return _objectMove.apply(this, arguments);
  }
  function _objectMove() {
    _objectMove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18(props) {
      var threeJs, object, position, rotation, rest;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            threeJs = props.threeJs, object = props.object, position = props.position, rotation = props.rotation, rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
            _context18.next = 3;
            return new Promise(function (resolve) {
              if (!threeJs.objectAnim) {
                threeJs.objectAnim = [];
              }
              threeJs.objectAnim.push( /*#__PURE__*/function () {
                var _ref13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17(startTime) {
                  var addPosition, addRotation;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        addPosition = {
                          x: position.x - object.position.x,
                          y: position.y - object.position.y,
                          z: position.z - object.position.z
                        };
                        addRotation = {
                          x: rotation.x - object.rotation.x,
                          y: rotation.y - object.rotation.y,
                          z: rotation.z - object.rotation.z
                        };
                        _context17.next = 4;
                        return objectAnim((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
                          threeJs: threeJs,
                          object: object,
                          addPosition: addPosition,
                          addRotation: addRotation
                        }, rest), {}, {
                          startTime: startTime
                        }));
                      case 4:
                        resolve();
                      case 5:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee17);
                }));
                return function (_x25) {
                  return _ref13.apply(this, arguments);
                };
              }());
            });
          case 3:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return _objectMove.apply(this, arguments);
  }
  return {
    objectMove: objectMove,
    objectsMove: objectsMove,
    cameraMoveByControls: cameraMoveByControls,
    cameraMoveToPosition: cameraMoveToPosition,
    getNCameraPosSpherical: getNCameraPosSpherical,
    startAnimation: startAnimation
  };
}